import * as React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui';

export default function Forbidden() {
	return (
		<div className="min-h-screen grid place-items-center p-8 bg-ground">
			<div className="text-center max-w-md">
				<p className="text-sm font-semibold text-danger-600 uppercase tracking-wider">
					403
				</p>
				<h1 className="mt-2 text-3xl font-semibold text-ink">Forbidden</h1>
				<p className="mt-3 text-ink-muted">
					You don’t have permission to view this page. Try a different account
					or ask an administrator for access.
				</p>
				<div className="mt-6">
					<Link to="/">
						<Button>Back to home</Button>
					</Link>
				</div>
			</div>
		</div>
	);
}
